<template>
  <router-view />
</template>

<script>
export default {
  name: 'ClimbingGroupsIndex'
}
</script>
